class BeeVideo
{
   constructor()
   {
      this.init();
   }

   init = () =>
   {
      this.initVideos();
   }

   onYoutubePlayerReady = (event, autoplay) =>
   {
      if( autoplay === 'true' )
      {
         event.target.mute();
         event.target.playVideo();
      }
   }


   buildYTVideos = () =>
   {
      const _self = this;
      let player;
      const containers = document.querySelectorAll('.media-frame.youtube');

      if (containers.length)
      {
         [].slice.call(containers).map( async (videoContainer) =>
         {
            const videoId = videoContainer.dataset.videoId;
            const videoUrl = videoContainer.dataset.videoUrl;
            const autoplay = videoContainer.dataset.autoplay;
            const loop = videoContainer.dataset.loop;
            const controls = videoContainer.dataset.controls;

            player = new YT.Player(videoContainer.id, {
               height: '360',
               width: '640',
               videoId: videoId,
               playerVars: {
                  enablejsapi: 1,
                  cc_load_policy: 0,
                  origin: window.location.href,
                  playsinline: 1,
                  fs: 0,
                  loop: loop === 'true' ? 1 : 0,
                  controls: controls === 'true' ? 1 : 0,
                  iv_load_policy: 3,
                  modestbranding: 1,
                  rel: 0,
                  showinfo: 0,
                  playlist: videoId
               },
               events: {
                  'onReady': (event) => _self.onYoutubePlayerReady(event, autoplay)
               }
            });
         });
      }
   }

   buildVimeoVideos = () =>
   {
      let VimeoPlayer;
      const containers = document.querySelectorAll('.media-frame.vimeo');

      if (containers.length)
      {
         [...containers].map(videoContainer =>
         {
            const videoId = videoContainer.dataset.videoId;
            const videoUrl = videoContainer.dataset.videoUrl;
            const autoplay = videoContainer.dataset.autoplay;
            const loop = videoContainer.dataset.loop;
            const controls = videoContainer.dataset.controls;

            const options = {
               byline: false,
               controls: eval(controls),
               loop: eval(loop),
               playsinline: true,
               responsive: false,
               title: false
            }
            VimeoPlayer = new Vimeo.Player(videoContainer?.id, options);
            if(autoplay)
            {
               VimeoPlayer.setVolume(0);
               VimeoPlayer.play();
            }
         });
      }
   }

   initVideos = () =>
   {
      const _self = this;
      const videoFiles = document.querySelectorAll('.bee-video [data-type="file"]');
      const youtubeVideos = document.querySelectorAll('.media-frame.youtube');
      const vimeoVideos = document.querySelectorAll('.media-frame.vimeo');

      window.onYouTubeIframeAPIReady = function ()
      {
         _self.buildYTVideos();
      }

      if (videoFiles.length > 0)
      {
         _self.handleVideoTypeFile(videoFiles);
      }
      if (youtubeVideos.length > 0)
      {
         const ytapi = document.createElement('script');
         ytapi.type = "text/javascript";
         ytapi.defer = "defer";
         ytapi.src = "https://www.youtube.com/iframe_api";
         document.body.appendChild(ytapi);
      }
      if (vimeoVideos.length > 0)
      {
         const vimeoapi = document.createElement('script');
         vimeoapi.type = "text/javascript";
         vimeoapi.defer = "defer";
         vimeoapi.src = "https://player.vimeo.com/api/player.js";
         vimeoapi.onload = function ()
         {
            _self.buildVimeoVideos();
         }
         document.body.appendChild(vimeoapi);
      }
   }

   handleVideoTypeFile = (videoFiles) =>
   {
      [...videoFiles].forEach(videoFile =>
      {
         const playbutton = videoFile.querySelector('.video-play-button');
         const video = videoFile.querySelector('video');

         if (playbutton)
         {
            const playIcon = playbutton.querySelector('.play-icon');
            const pauseIcon = playbutton.querySelector('.pause-icon');

            playbutton.addEventListener('click', function ()
            {
               if (video.paused)
               {
                  video.play();
               } else
               {
                  video.pause();
               }
            }, false);

            ['play', 'playing'].forEach(event =>
            {
               video.addEventListener(event, () =>
               {
                  playIcon.style.display = 'none';
                  pauseIcon.style.display = 'block';
               });
            });

            video.addEventListener('pause', () =>
            {
               playIcon.style.display = 'block';
               pauseIcon.style.display = 'none';
            });

         }
      });
   }
}

new BeeVideo();